import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-down",
  "use": "icon-down-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-down\"><path fill-rule=\"evenodd\" d=\"M20.811 6h-1.776a.382.382 0 00-.306.155L12 15.333 5.272 6.155A.382.382 0 004.966 6H3.19a.188.188 0 00-.154.298l8.351 11.393a.76.76 0 001.224 0l8.352-11.393A.187.187 0 0020.81 6z\" clip-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol